import { Link } from 'react-router-dom';
import Header from './home/components/Header';
import Footer from './home/components/Footer';
import { siteConfig } from '../config/site';
import PageMeta from '../components/PageMeta';

const SobreNos = () => {
  const isClimatizacaoSite = siteConfig.domain === 'alphaclimatizacao.pt';
  const isCleanSite = siteConfig.domain === 'alphaclean.pt';

  return (
    <div className="min-h-screen bg-white">
      <PageMeta
        title="Sobre Nós"
        description={`${siteConfig.aboutUs}. Conheça a equipa, a missão e as garantias que oferecemos.`}
        path="/sobre-nos"
      />
      <Header />
      <main className="pt-20">
        <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Sobre Nós
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              {siteConfig.aboutUs}
            </p>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Quem Somos</h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {siteConfig.aboutUs},
                com anos de experiência no mercado. {isCleanSite
                  ? 'Tratamos da limpeza de condomínios, escritórios, residências, alojamento local, restauração e lojas com equipas fixas, identificadas e produtos incluídos.'
                  : isClimatizacaoSite
                  ? 'Acompanhamos o cliente em todas as fases: pré-instalação em obra, escolha e venda do equipamento, instalação, manutenção anual e peças de reposição.'
                  : 'Oferecemos soluções completas para todos os problemas relacionados com canalização, desde desentupimentos urgentes até remodelações completas.'}
              </p>
              
              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">A Nossa Missão</h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {isCleanSite
                  ? `Manter os espaços dos nossos clientes impecáveis, com equipas de confiança, supervisão regular e preços transparentes em ${siteConfig.address.city}. Comprometemo-nos com o rigor e a consistência na limpeza.`
                  : isClimatizacaoSite
                  ? `Proporcionar conforto térmico com equipamentos bem dimensionados e instalações bem executadas em ${siteConfig.address.city}. Comprometemo-nos a recomendar apenas o que faz sentido para cada espaço, com transparência de preço e garantia em tudo o que fazemos.`
                  : `Proporcionar serviços de canalização de alta qualidade, com atendimento rápido, técnicos especializados e soluções eficientes para os nossos clientes em ${siteConfig.address.city}. Comprometemo-nos a resolver os seus problemas de canalização com profissionalismo, garantia e preços transparentes.`}
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Porquê Escolher-nos</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-3 mb-6">
                <li>Técnicos especializados e certificados</li>
                <li>Atendimento 24h para emergências</li>
                <li>Equipamento profissional de última geração</li>
                <li>Garantia em todos os serviços</li>
                <li>Preços transparentes e competitivos</li>
                <li>Resposta rápida e eficiente</li>
                <li>Anos de experiência no mercado</li>
              </ul>

              <div className="mt-12">
                <Link
                  to="/"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors inline-block"
                >
                  Voltar à página inicial
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SobreNos;

